module.exports = __webpack_public_path__ + "static/naey-49d0bbfea1f7ac069d6a7aef1cd5ad70.png";